import { ToggleConfigType } from './index';

// current feature toggle names
export const TEST_TOGGLE = 'test-toggle';

export const toggleConfig: ToggleConfigType = [
  { name: TEST_TOGGLE, default: 'false' },
];
